import React, { Component } from 'react'

class NotFound extends Component<{}> {
  render () {
    return (
      <div>
        <h2 className='mb-5'>Page Not Found</h2>
      </div>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/404/404.js